
import React from 'react';

interface SkillBadgeProps {
  name: string;
  level: number;  // 1-5 (Beginner to Expert)
  icon?: React.ReactNode;
  category: string;
}

const SkillBadge: React.FC<SkillBadgeProps> = ({
  name,
  level,
  icon,
  category,
}) => {
  const getCategoryColor = () => {
    switch (category.toLowerCase()) {
      case 'frontend':
        return 'bg-blue-500/10 border-blue-500/30 text-blue-600';
      case 'backend':
        return 'bg-green-500/10 border-green-500/30 text-green-600';
      case 'database':
        return 'bg-amber-500/10 border-amber-500/30 text-amber-600';
      case 'devops':
        return 'bg-purple-500/10 border-purple-500/30 text-purple-600';
      case 'tools':
        return 'bg-gray-500/10 border-gray-500/30 text-gray-600';
      default:
        return 'bg-portfolio-blue/10 border-portfolio-blue/30 text-portfolio-blue';
    }
  };

  const renderSkillLevel = () => {
    const dots = [];
    for (let i = 1; i <= 5; i++) {
      dots.push(
        <div
          key={i}
          className={`w-1.5 h-1.5 rounded-full ${
            i <= level ? 'bg-current' : 'bg-current/30'
          }`}
        ></div>
      );
    }
    return dots;
  };

  return (
    <div 
      className={`flex items-center rounded-lg border px-3 py-2 transition-all duration-300 hover:scale-105 ${getCategoryColor()}`}
    >
      {icon && <div className="mr-2">{icon}</div>}
      <span className="text-sm font-medium">{name}</span>
      <div className="ml-auto flex space-x-1">
        {renderSkillLevel()}
      </div>
    </div>
  );
};

export default SkillBadge;
